import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { Select } from "components/common";
const StyledLabel = styled.label`
  font-weight: bold;
  margin-bottom: 5px;
  display: inline-block;
  font-size: 14px;
  background: none;
`;
const HelpText = styled.span`
  color: ${(props) => props.theme.colors.gray["50"]};
`;
const Autocomplete = ({
  fieldName,
  label,
  clearable = false,
  required = false,
  helpText = "",
  options = []
}) => /* @__PURE__ */ React.createElement(Field, { name: fieldName, help: helpText }, ({ field: { name, value, onChange } }) => /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(StyledLabel, null, label), /* @__PURE__ */ React.createElement(
  Select,
  {
    id: fieldName,
    name,
    clearable,
    required,
    allowCreate: true,
    onChange: (index) => onChange({ target: { value: index, name } }),
    options,
    value
  }
), helpText && /* @__PURE__ */ React.createElement("span", { className: "help-block" }, /* @__PURE__ */ React.createElement(HelpText, null, helpText))));
export default Autocomplete;
